import { useContext } from "react";
import { VerifiedUsersContext } from "../context/verifiedUserProvider";
import { PERMISSIONS } from "../constants/permissions";
import { getAuth } from "firebase/auth";

export function useVerifiedUser(permission = [PERMISSIONS.FULL]) {
  const { verifiedUsers, isLoading } = useContext(VerifiedUsersContext);
  const loggedInUser = getAuth().currentUser?.email?.toLowerCase();

  const isVerified = verifiedUsers.some((e) => {
    if (e.email?.toLowerCase() !== loggedInUser) return false;
    if (e.permissions?.includes(PERMISSIONS.FULL)) return true;
    const perms = permission instanceof Array ? permission : [permission];
    return perms.some((p) => e.permissions?.includes(p));
  });

  return { isVerified, isLoading };
}
